<div class="title-container">
  <h3 class="title">
    {{ 'ACTIVE_ITEMS.TITLE' | translate }}
  </h3>
</div>

<ng-container *ngIf="currentlyActiveItems$ | async as items">
  <inventory-ui-item-list [items]="items" [showStatus]="true" />
</ng-container>
